import { GroupRegistrationForm } from "../../organisms/form/GroupRegistrationForm";
import { MainTemplate } from "../../templates/MainTemplate";
import { useGroupRegistration } from "./hook";

export const GroupRegistrationPage: React.FC = () => {
  const { clients, handleCancel, handleRegisterGroup } = useGroupRegistration();

  return (
    <MainTemplate title="新規グループ登録">
      <GroupRegistrationForm
        clients={clients ?? []}
        onCancel={handleCancel}
        handleSubmit={handleRegisterGroup}
      />
    </MainTemplate>
  );
};
